import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ProfileFollowModel } from '../models/profile-follow.model';
import { MenuItem } from '../models/rich-data.model';
import { GetTranslationService } from './get-translation.service';
import { ToastMachineService } from './toast-machine.service';

@Injectable({
  providedIn: 'root'
})
export class FollowService {

  follows: ProfileFollowModel[] = [];

  constructor(
    private http: HttpClient,
    private toaster: ToastMachineService,
    private translateServ: GetTranslationService
  ) { }

  getFollows(): Promise<ProfileFollowModel[]> {
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiURL + `/profile_follows`).subscribe(
        {
          next: async (resp: ProfileFollowModel[]) => {
            this.follows = resp;
            resolve(resp);
          },
          error: err => {
            const error = err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          }
        }
      );
    });
  }

  postFollow(menuItem: MenuItem, isFollow: boolean, profileId: number): Promise<ProfileFollowModel[]> {
    return new Promise((resolve, reject) => {

      const FOLLOWDATA = new ProfileFollowModel(menuItem, isFollow, profileId);

      this.http.post(environment.apiURL + `/profile_follows`, FOLLOWDATA).subscribe(
        {
          next: async (resp: ProfileFollowModel[]) => {
            if (isFollow) {
              const MSG = await this.translateServ.getTranslate('Successfuly Followed');
              this.toaster.toastMachine(MSG, 'primary', 3000);
            } else {
              const MSG = await this.translateServ.getTranslate('Successfuly Unfollowed');
              this.toaster.toastMachine(MSG, 'warning', 3000);
            }

            await this.getFollows();
            resolve(resp);
          },
          error: err => {
            const error = err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          }
        }
      );
    });
  }
}
